<!--甲状腺功能（可选）-->
<script setup>
import { computed, reactive,ref } from "vue";
import { useCrfStore } from "@/stores/crf";
import check from "./check.vue";
import upload from "@/components/upload1.vue"
import {useCommonStore} from "@/stores/common.js"
const commonStore = useCommonStore()
//不是筛选期
let notScreen = ref(false)
notScreen.value = commonStore.funNotScreen

//是不是v0
let isv0 = ref(false)
isv0.value = commonStore.isV0


// 定义组件属性
const props = defineProps({
  formModel: {},
  type: null
});

// 表单对象
const model = reactive(props.formModel);
const crfStore = useCrfStore();


// 节省代码长度，在模板中使用
const crfFields = computed(() => {
  return model.fields[`${props.type}`];
});

// 字段自动校验用于赋值 prop
const itemProp = function(prop) {
  return `fields['${props.type}']['${prop}']`;
};
</script>
<template>
  <template v-if="crfFields">
     <div style="display: flex;">

      <h2>甲状腺功能（可选）</h2>
      <upload :type="props.type" :data="model" name="jzxgn"></upload>
      <check :period="props.type" text="甲状腺功能（可选）" :data="model" v-if="model.checkdata.ischeck == '是'"></check>
    </div>
    <el-form-item label="甲状腺功能是否适用肝筛选期数据"  v-if="crfFields && isv0" class="redStar">
      <el-radio-group v-if="notScreen" v-model="crfFields['甲状腺功能是否适用肝筛选期数据']">
        <el-radio label="是" prop="是"></el-radio>
        <el-radio label="否" prop="否"></el-radio>
      </el-radio-group>
    </el-form-item>
    <template v-if="crfFields['甲状腺功能是否适用肝筛选期数据'] == '否' || !isv0">
        <el-form-item :label="notScreen?'是否新增甲状腺功能（可选）':'甲状腺功能（可选）'" class="redStar">
            <el-radio-group v-model="crfFields['是否新增甲状腺功能']">
              <el-radio label="是" prop="是"></el-radio>
              <el-radio label="无" prop="无"></el-radio>
            </el-radio-group>
        </el-form-item>
        
        <template v-if="crfFields['是否新增甲状腺功能'] == '是'">

            <el-form-item label="甲状腺素(T4)(nmol/L)" :prop="itemProp(`甲状腺素(T4)`)" :rules="crfStore.textRules(`甲状腺素`,true)"  class="redStar">
              <el-input v-model="crfFields['甲状腺素(T4)']" autocomplete="off">
                <template #append>nmol/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="三碘甲状原氨酸(T3)(nmol/L)" :prop="itemProp(`三碘甲状原氨酸(T3)`)" :rules="crfStore.textRules(`三碘甲状原氨酸`,true)" class="redStar">
              <el-input v-model="crfFields['三碘甲状原氨酸(T3)']" autocomplete="off">
                <template #append>nmol/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="促甲状腺激素(TSH)(uIU/ml)" :prop="itemProp(`促甲状腺激素(TSH)`)" :rules="crfStore.textRules(`促甲状腺激素`,true)" class="redStar">
              <el-input v-model="crfFields['促甲状腺激素(TSH)']" autocomplete="off">
                <template #append>uIU/ml</template>
              </el-input>
            </el-form-item>
            <el-form-item label="游离T3(pmol/L)" :prop="itemProp(`游离T3`)" :rules="crfStore.textRules(`游离T3`,true)" class="redStar">
              <el-input v-model="crfFields['游离T3']" autocomplete="off">
                <template #append>pmol/L</template>
              </el-input>
            </el-form-item>
            <el-form-item label="游离T4(pmol/L)" :prop="itemProp(`游离T4`)" :rules="crfStore.textRules(`游离T4`,true)" class="redStar">
              <el-input v-model="crfFields['游离T4']" autocomplete="off">
                <template #append>pmol/L</template>
              </el-input>
            </el-form-item>
        </template>
    </template>


    <!--<el-form-item :label="notScreen?'是否新增甲状腺功能（可选）':'甲状腺功能（可选）'"  v-if="crfFields && notScreen" class="redStar">
         <el-radio-group v-if="notScreen" v-model="crfFields['是否新增甲状腺功能']">
          <el-radio label="是" prop="是"></el-radio>
          <el-radio label="否" prop="否"></el-radio>
        </el-radio-group>

    </el-form-item>
     -->
    
  </template>
</template>

<style scoped>
</style>